<template>
    <section>
        <div class="video-box df jcsb">
            <router-link v-for="v in studios" :key="v.id" :to="`/studios/${v.id}`" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-hot"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-like"></i>{{$view(v.fans)}}
                    </div>
                </div>
                <div class="video-title">{{v.name}}</div>
            </router-link>
        </div>
    </section>
</template>

<script>
    export default {
        data: () => ({
            studios: [],
        }),
        beforeMount() {
            this.api.get('studios').then(e => this.studios = e, this.err);
            this.$share('工作室');
        },
    }
</script>

<style scoped>
    @import '../../../static/css/home/video-list.css';

    .video-thumb {
        height: 45.07vw;
    }

    .video-title {
        height: 4.8vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/home/Studio.vue